<template>
  <div class="popWrap" style="overflow:auto;">
    <div class="popup">
      <div class="popContain">
        <div class="popCont">
          <div class="popHead">
            <h1 class="titH1">나의 주문 상품</h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <section v-if="productListLength > 0">
                <ul class="prdList line">
                  <li v-for="(product, productIndex) in productList" :key="productIndex">
                    <div class="block">
                      <div class="prdItem xs">
                        <div class="imgArea">
                          <span class="img">
                            <img
                              :src="product.product.thumbnail ? product.product.thumbnail : '/img/error_image.jpg'"
                              :alt="product.product.displayName"
                              onerror="this.src='/img/error_image.jpg';"
                            />
                          </span>
                        </div>
                        <div class="infoArea">
                          <div class="tit row2">
                            <span v-text="product.product.productName"></span>
                          </div>
                          <div class="txtItem">
                            <span v-text="product.product.model"></span>
                          </div>
                        </div>

                        <div v-if="product.product.productCode" class="btnGroup">
                          <button type="button" class="btn_s s" @click="selectProduct(productIndex)">선택</button>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </section>

              <section v-if="productListLength == 0">
                <div class="resultMsg noSrch">
                  <p class="copy">주문하신 상품이 없습니다.</p>
                </div>
              </section>
            </div>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import * as customjs from '@/../static/js/m.front.js';

export default {
  name: 'MyOrderListPop',
  components: {},
  data() {
    return {
      productList: [],
      productListLength: -1,
    };
  },
  updated() {
    customjs.listInit();
  },
  mounted() {
    // 주문 상품 리스트 조회
    ApiService.service('GET', '/user/auth/products')
      .then(({ data }) => {
        if (data.isSucceed) {
          this.productList = data.result;
          this.productListLength = data.result.length;
        } else {
          this.productListLength = 0;
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });
  },
  methods: {
    selectProduct(index) {
      let product = this.productList[index];

      this.$emit('selectItem', product);
    },
  },
};
</script>
